import { render, staticRenderFns } from "./ClinicalCasePage.vue?vue&type=template&id=b936941a&"
import script from "./ClinicalCasePage.vue?vue&type=script&lang=js&"
export * from "./ClinicalCasePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports